import { AxiosResponse } from 'axios';
import store from '@store/store';
import api from '@core/services/api';
import { login_fetching, logout, login_success, login_error, current_fetching, current_success, current_error } from '@core/slice/login.slice';
import { IAuth, IToken } from '@core/models';
import { ICredentials } from './interfaces';
import { decodeToken } from '@core/utils';
import { getTokenLocalStorage } from '@core/services';

class LoginService {
    currentUser() {

        store.dispatch(current_fetching());

        try {
            const token = getTokenLocalStorage() ?? '';

            const currentTime = Date.now() / 1000;

            const decoded: IToken = decodeToken(token);

            if (decoded.exp > currentTime) {

                store.dispatch(current_success({ matricula: decoded.matricula, nome: decoded.nome, apelido: decoded.apelido, cargo: decoded.cargo, empresa: decoded.empresa, role: decoded.role }));
            } else {

                this.logout();
            }

        } catch (error: any) {
            store.dispatch(current_error(error));
            this.logout();
        }
    }
    logout(): void {
        store.dispatch(logout());
    }
    login(credentials: ICredentials) {
        const { cpf, matricula, password } = credentials;
        store.dispatch(login_fetching());
        api.post<IAuth>('/api/auth/signin', {
            cpf,
            matricula,
            password
        })
            .then((response: AxiosResponse<IAuth>) => {
                store.dispatch(login_success(response.data));
                this.currentUser();
            })
            .catch((e: any) => {
                store.dispatch(login_error(e.response?.data?.message || 'Erro desconhecido'));
            });
    }
}
export const loginService: LoginService = new LoginService();
